import { Box } from '@veracity/vui'
import { useState } from 'react'

import { PageContainer, PageSearchInput } from '@/components'
import { useCurrentUser } from '@/hooks'
import { filterBy } from '@/utils'

import {
  PortfoliosListAddPortfolioDialog,
  PortfoliosListPreview
} from './components'
import { usePortfoliosList } from './hooks'

export const PortfoliosListPage = () => {
  const [searchValue, setSearchValue] = useState('')

  const { portfolios, isFetching } = usePortfoliosList()
  const { isUser } = useCurrentUser()

  const filteredPortfolios =
    portfolios?.filter(x => filterBy(searchValue, [x.name, x.description])) ||
    []

  return (
    <PageContainer
      loading={isFetching}
      header={<PageContainer.Breadcrumbs items={[{ title: 'Portfolios' }]} />}
      menuBar={
        <Box w="100%" justify="space-between">
          <PageSearchInput onChange={setSearchValue} />
          {isUser && <PortfoliosListAddPortfolioDialog />}
        </Box>
      }>
      <PortfoliosListPreview portfolios={filteredPortfolios} />
    </PageContainer>
  )
}
